import { render, staticRenderFns } from "./changeMsisdnDialog.vue?vue&type=template&id=0f8fc2ce&scoped=true"
import script from "./changeMsisdnDialog.vue?vue&type=script&lang=ts"
export * from "./changeMsisdnDialog.vue?vue&type=script&lang=ts"
import style0 from "./changeMsisdnDialog.vue?vue&type=style&index=0&id=0f8fc2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fc2ce",
  null
  
)

export default component.exports